import styled from '@emotion/styled';
import { Responsive } from '../../utils';

export const StyledContactCardPhoneLink = styled.a<{}>`
	display: none;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: block;
	}
`;
